import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

const getToken = () => {
  try {
    const localData = localStorage.getItem("loggedUser");
    if (localData) {
      const parsed = JSON.parse(localData);
      if (parsed.token) return parsed.token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
    }
    const sessionData = sessionStorage.getItem("user");
    if (sessionData) {
      const parsed = JSON.parse(sessionData);
      if (parsed.token) return parsed.token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const fetchDailySalesReport = createAsyncThunk(
  "reports/fetchDailySalesReport",
  async ({ date, from, to, page = 1 }, thunkAPI) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      
      let params = `page=${page}`;
      if (date) params += `&date=${date}`;
      if (from) params += `&from=${from}`;
      if (to) params += `&to=${to}`;
      
      const response = await axios.get(
        `${BASE_URL}/dashboard/reports/daily-sales?${params}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    dailySales: null,
    meta: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailySalesReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailySalesReport.fulfilled, (state, action) => {
        state.loading = false;
        state.dailySales = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchDailySalesReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reportsSlice.reducer;
